const headerBgColor = ref<string | null>(null);

export function useHeaderBgColor() {
    return headerBgColor;
}

export function useControlHeaderBgColor(color: string | null) {
    headerBgColor.value = color;
}
